export default {
  methods: {
    getLocalizedMuiValue (value, fallback = '', locale = null) {
      if (locale === null) {
        locale = this.$locale.getCurrentLocale()
      }
      return value[locale] || fallback
    }
  }
}
